/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceInUseDto } from '../../models/device-in-use-dto';

export interface GetGroupDevicesByFacilityId$Params {
  facilityId: number;
}

export function getGroupDevicesByFacilityId(http: HttpClient, rootUrl: string, params: GetGroupDevicesByFacilityId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceInUseDto>>> {
  const rb = new RequestBuilder(rootUrl, getGroupDevicesByFacilityId.PATH, 'get');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DeviceInUseDto>>;
    })
  );
}

getGroupDevicesByFacilityId.PATH = '/api/regdevice/facility/{facilityId}';
